
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  onCreateConnection: () => void;
}

export function EmptyState({ onCreateConnection }: EmptyStateProps) {
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center animate-fade-in">
      <div className="h-20 w-20 rounded-full bg-primary flex items-center justify-center mb-6">
        <span className="text-primary-foreground font-bold text-2xl">WM</span>
      </div>
      <h3 className="text-xl font-semibold mb-2">{t('emptyState.title')}</h3>
      <p className="text-muted-foreground mb-4 max-w-md">
        {t('emptyState.description')}
      </p>
      <Button 
        onClick={onCreateConnection}
        className="bg-primary hover:bg-primary/90 text-primary-foreground mb-2"
      >
        <Plus className="mr-2 h-4 w-4" />
        Add Child's WhatsApp
      </Button>
      <p className="text-sm text-muted-foreground max-w-md">
        {t('helpers.qrSetupNext')}
      </p>
    </div>
  );
}
